(() => {
  const target = document.querySelector('#collection');
  if (!target) return;
  const link = document.createElement('a');
  link.className = 'skip-hills';
  link.href = '#collection';
  link.innerHTML = 'Skip to the hills <span aria-hidden="true">↓</span>';
  document.body.appendChild(link);
  let shown = false, queued = false;
  function update() {
    queued = false;
    let next = window.scrollY > window.innerHeight * 0.35 && target.getBoundingClientRect().top > window.innerHeight * 0.75;
    if (next) {
      const w = link.offsetWidth || 170, h = link.offsetHeight || 44, cs = getComputedStyle(link);
      const right = window.innerWidth - (parseFloat(cs.right) || 16), bottom = window.innerHeight - (parseFloat(cs.bottom) || 56);
      const box = { l: right - w - 8, r: right + 8, t: bottom - h - 8, b: bottom + 8 };
      next = ![...document.querySelectorAll('a.cp-gold, .ridge-steps li.is-active, .text-link, [data-hill-cta], .button, .manifesto a, #sizes a, #sizes button')].some(el => { if (el === link || el.closest('.site-header')) return false; const q = el.getBoundingClientRect(); return q.width && q.height && q.left < box.r && q.right > box.l && q.top < box.b && q.bottom > box.t; });
    }
    if (next !== shown) { shown = next; link.classList.toggle('is-shown', next); link.tabIndex = next ? 0 : -1; }
  }
  link.tabIndex = -1;
  window.addEventListener('scroll', () => { if (!queued) { queued = true; requestAnimationFrame(update); } }, { passive: true });
  window.addEventListener('resize', update);
  link.addEventListener('click', e => {
    e.preventDefault();
    const offset = parseFloat(getComputedStyle(document.documentElement).scrollPaddingTop) || 0;
    window.scrollTo({ top: target.getBoundingClientRect().top + window.scrollY - offset, behavior: 'instant' });
    target.setAttribute('tabindex', '-1');
    target.focus({ preventScroll: true });
  });
  update();
})();
